import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';

import { ClientBilling } from './types';

import { SuccessData } from 'types/api';

export const clientMutations = getMutations({
  syncSample: {
    action: async (): Promise<{ synced: number }> => {
      return executeApiCall({
        path: '/clients/sync-sample',
        method: 'post',
        payload: {},
      });
    },

    messages: {
      suppressSuccess: true,
    },
  },

  syncClientBilling: {
    action: async ({ id }: { id: string }): Promise<ClientBilling> => {
      return executeApiCall({
        path: '/clients/billing/sync-sample',
        method: 'post',
        payload: {
          client: id,
        },
      });
    },

    messages: {
      success: {
        title: 'Synced with with sample',
      },

      error: {
        title: 'Error syncing info',
      },
    },
  },

  settleBalance: {
    action: async ({
      balanceId,
      client,
      justification,
    }: {
      client: string;
      balanceId: string;
      justification: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/clients/balance',

        method: 'post',

        payload: {
          client,
          id: balanceId,
          justification,
        },
      });
    },
  },
});
